import React, { useState } from "react";
import { Auth } from 'aws-amplify';
import cryptoRandomString from 'crypto-random-string';
import { parsePhoneNumberFromString } from 'libphonenumber-js'

import SignUp from '../Components/Login/SignUp/SignUp'
import SignIn from '../Components/Login/SignIn/SignIn'
import Verify from '../Components/Login/Verify/Verify'

const SIGN_IN = 'SIGN_IN';
const SIGN_UP = 'SIGN_UP';
const VERIFY = 'VERIFY';

export default function Login(props) {
    const [authType, setAuthType] = useState(SIGN_IN);
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState(false);
    const [phoneCountry, setPhoneCountry] = useState("GB");
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState(false);
    const [cognitoUser, setCognitoUser] = useState(undefined);
    const [challengeAnswer, setChallengeAnswer] = useState("");
    const [challengeAnswerWrong, setChallengeAnswerWrong] = useState(false);
    const [loading, setLoading] = React.useState(false);

    const goToSignIn = () => {
        setAuthType(SIGN_IN);
        setEmailError(false)
    };

    const goToSignUp = () => {
        setAuthType(SIGN_UP);
        setEmailError(false)
    };

    const handleSignUp = async (event) => {
        event.preventDefault();
        setNameError(false);
        setEmailError(false);
        setPhoneError(false);

        const phoneNumber = parsePhoneNumberFromString(phone, phoneCountry)    

        let formValid = true;
        if (name.length === 0) {
            setNameError(true);
            formValid = false;
        }

        if (email.length === 0) {
            setEmailError(true);
            formValid = false;
        }    

        if (!phoneNumber || !phoneNumber.isValid()) {
            console.log("Invalid Phone number: ", phoneNumber);
            setPhoneError(true);
            formValid = false;
        }

        if (!formValid) {
            return
        }

        setLoading(true);
        
        const params = {
            username: email.toLowerCase(),
            password: cryptoRandomString({length: 30}),
            attributes: {
                name: name,
                phone_number: phoneNumber.number,
            }
        };

        try {
            await Auth.signUp(params);
            const user = await Auth.signIn(params.username)
            setCognitoUser(user);
            setAuthType(VERIFY);
            setLoading(false);
        } catch (err) {
            console.log(err);
            console.log("ERROR_CODE: ",err.code);
            setLoading(false);

            if (err.code === "UsernameExistsException") {
                handleSignIn({preventDefault: ()=>{}});
            }
        }
    };

    const handleSignIn = async(event) => {
        event.preventDefault();
        setEmailError(false);

        if (email.length === 0) {
            setEmailError(true);
            return
        }  

        setLoading(true);
        
        try {
            const user = await Auth.signIn(email.toLowerCase())
            setCognitoUser(user);
            setAuthType(VERIFY);
            setLoading(false);
        } catch (err) {
            console.log(err);
            console.log("ERROR_CODE: ",err.code);
            setLoading(false);

            if (err.code === "UserNotFoundException") {
                setAuthType(SIGN_UP);
            }
        }
    };

    const handleVerify = async (event) => {
        event.preventDefault();
        setLoading(true);
        setChallengeAnswerWrong(false);

        if (challengeAnswer.length === 0){
            setLoading(false);
            setChallengeAnswerWrong(true);
            return
        }

        try {
            const verifiedUser = await Auth.sendCustomChallengeAnswer(cognitoUser, challengeAnswer)
            if (verifiedUser.challengeName !== 'CUSTOM_CHALLENGE') {                
                props.handleAuthorisation(verifiedUser.attributes)
            } else {
                setChallengeAnswerWrong(true);
            }
            setLoading(false);
        } catch (err) {
            setEmail("");
            setChallengeAnswer("");
            setLoading(false);
            setAuthType(SIGN_IN);
        }
    };

    return (
        <>
            {authType === SIGN_IN ? 
                <SignIn email={email} setEmail={setEmail} emailError={emailError} handleSignIn={handleSignIn} goToSignUp={goToSignUp} loading={loading} /> 
            : 
                null
            }

            {authType === SIGN_UP ? 
                <SignUp name={name} setName={setName} nameError={nameError} email={email} setEmail={setEmail} emailError={emailError} phone={phone} setPhone={setPhone} phoneError={phoneError} phoneCountry={phoneCountry} setPhoneCountry={setPhoneCountry} handleSignUp={handleSignUp} goToSignIn={goToSignIn} loading={loading}/>
            :
                null
            }

            {authType === VERIFY ? 
                <Verify challengeAnswer={challengeAnswer} challengeAnswerWrong={challengeAnswerWrong} setChallengeAnswer={setChallengeAnswer} handleVerify={handleVerify} loading={loading}/> 
            : 
            null
            }
        </>
    );
}
